// extracted by mini-css-extract-plugin
export default {"root":"FilesFolderLogViewer__root--3zELZ","header":"FilesFolderLogViewer__header--2YMwE","tabs":"FilesFolderLogViewer__tabs--1UFky"};